import { ChatBotDataList } from '@/Workspaces/ChatBotData/ChatBotDataList'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/workspace/$workspaceId/chatBotData/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ChatBotDataList />
}
